import Cookies from 'js-cookie';

import { isDevEnvironmentSwitcherEnabled } from './environments';

const COOKIE_KEY = 'DEV_AUTOMATION_NOTIFICATIONS';
const cookieOptions = { path: '/' };

export const AUTOMATION_NOTIFICATIONS_COOKIE_KEY = COOKIE_KEY;

export const isAutomationNotificationsFlagAvailable = () => isDevEnvironmentSwitcherEnabled();

/** Hidden unless Dev Tools → Custom → Automation notifications is on. */
export const isAutomationNotificationsEnabled = () => {
    if (!isAutomationNotificationsFlagAvailable()) return false;
    return Cookies.get(COOKIE_KEY) === '1';
};

export const setAutomationNotificationsEnabled = (enabled) => {
    if (!isAutomationNotificationsFlagAvailable()) return;

    if (enabled) {
        Cookies.set(COOKIE_KEY, '1', cookieOptions);
        return;
    }

    Cookies.remove(COOKIE_KEY, cookieOptions);
};
